module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/aq683-81b199bf6343ac96dbe14d973d1ff4bf.jpg";